import React, { ReactNode } from 'react';
import styled from 'styled-components';

const SkeletonLoaderContainer = styled.div`
  margin-top: var(--cc_size_spacing_xl);
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  column-gap: var(--cc_size_spacing_s);
  row-gap: var(--cc_size_spacing_s);
`;

const Placeholder = styled.div`
  aspect-ratio: 1;
  border-radius: var(--cc_size_border_radius_l);
  background-color: var(--cc_color_background_3);
`;

type SkeletonLoaderProps = {
  accessibilityLabel: string;
  placeholderCount: number;
};

export const SkeletonLoader = ({
  accessibilityLabel,
  placeholderCount,
}: SkeletonLoaderProps) => {
  const renderContainers = (): ReactNode => {
    const containers = [];
    for (let i = 0; i < placeholderCount; i += 1) {
      containers.push(
        <Placeholder
          data-testid="mutliselect-picker__skeleton-loader-placeholder"
          key={`placeholder-${i}`}
        />,
      );
    }
    return containers;
  };

  return (
    <SkeletonLoaderContainer aria-label={accessibilityLabel}>
      {renderContainers()}
    </SkeletonLoaderContainer>
  );
};
